import MasterService from "./MasterService";

const ReconciliationService = {
    ...MasterService,

    getReconciliationListing(params: object) {
        return this.post('/recon/getReconList', params)
    },
    PaymentApproveReject(params: object) {
         return this.post('/recon/PaymentApproveReject', params)
    },
    AssignPayment(params: object) {
         return this.post('/recon/assignPayment', params)
    },
    bulkPaymentAssignee(params: object) {
        return this.post('/recon/assignBulkPayment', params)
    },
}

export default ReconciliationService;